import { AssignmentsDocument, AssignmentsQuery, AssignmentsQueryVariables } from '../types';
import { client } from '../../client';

// Roles: [Shared]
// Get all the assignments, can retrieve only isSubmitted/notSubmitted
export async function getAssignments(variables: AssignmentsQueryVariables): Promise<Readonly<AssignmentsQuery>> {
  try {
    const result = await client.query<AssignmentsQuery, AssignmentsQueryVariables>({
      query: AssignmentsDocument,
      variables,
      fetchPolicy: 'network-only',
    });
    return result.data;
  } catch (error) {
    throw Error(error);
  }
}
